/**
 * Created by ray on 2017/12/16.
 */

import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot,  RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../../shared/service/auth.service';
import {Constants} from "../constants";
import {MsgService} from "../service/message.service";

@Injectable()
export class BaseMuntGuard implements CanActivate {

  permissionNames;

  constructor(private router:Router, private authService:AuthService, public constants:Constants, private msgService:MsgService) {
  }

  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    if (this.authService.hasRoles(this.permissionNames)) {
      return true;
    } else {
      this.msgService.showError('Unauthorized', 'You do not have the permission to access this module.');
      const defaultUrl = this.authService.getDefaultUrl();
      if (defaultUrl) {
        state.url = defaultUrl;
      } else {
        state.url = '/login';
      }
    }
    this.router.navigate([state.url]);
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/guards/base.munt.guard.ts